"use client";

import { useEffect, useRef } from "react";
import blocks from "@/components/page/blocks.module.css";
import { research } from "@/content/research";
import { worldBus } from "@/lib/world-bus";
import styles from "./research.module.css";

// "Cómo piensa" (guía 7.4 y 8.2): al avanzar por cada paso, se ilumina su zona en el
// árbol de la escena (raíces, tronco, ramas, copa). El paso activo es el que cruza la
// mitad de la pantalla.
export function HowItThinks() {
  const listRef = useRef<HTMLOListElement>(null);

  useEffect(() => {
    const list = listRef.current;
    if (!list) return;
    const items = Array.from(list.querySelectorAll<HTMLElement>("[data-step]"));
    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          const i = Number((e.target as HTMLElement).dataset.step);
          if (e.isIntersecting) {
            worldBus.treeZone = i;
            items.forEach((el, k) => el.toggleAttribute("data-active", k === i));
          } else if (worldBus.treeZone === i) {
            worldBus.treeZone = -1;
            (e.target as HTMLElement).removeAttribute("data-active");
          }
        }
      },
      // Una franja angosta en el centro de la pantalla: un solo paso activo a la vez.
      { rootMargin: "-45% 0px -45% 0px", threshold: 0 },
    );
    items.forEach((el) => io.observe(el));
    return () => {
      io.disconnect();
      worldBus.treeZone = -1;
    };
  }, []);

  return (
    <ol ref={listRef} className={styles.steps}>
      {research.how.steps.map((s, i) => (
        <li key={s.title} data-step={i} className={styles.step}>
          <span className={styles.stepNum} aria-hidden="true">
            {String(i + 1).padStart(2, "0")}
          </span>
          <div>
            <h3 className={blocks.stepTitle}>
              {s.title} <code className={styles.tech}>{s.tech}</code>
            </h3>
            <p className={blocks.stepBody}>{s.body}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}
